document.addEventListener('variant:change', function(event) {
  const variant = event.detail && event.detail.variant;
  if (!variant) return;
  document.querySelectorAll('[data-outerwear-coat-name]').forEach(function(name) { name.textContent = variant.title; });
});
document.addEventListener('click', function(event) {
  const thumbnail = event.target.closest('.product-gallery__thumbnail');
  const heading = document.querySelector('[data-outerwear-coat-name]');
  if (!thumbnail || !heading) return;
  const index = Number(thumbnail.dataset.mediaPosition) - 1;
  if (index < 0 || index > 3) return;
  const section = heading.closest('.shopify-section');
  const choices = section.querySelectorAll('variant-picker input[type="radio"]');
  if (choices[index] && !choices[index].checked) choices[index].click();
});
